import React, { useContext } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import { UpdateContext } from "../main-context";

export default function Online() {
  const location = useLocation();
  const match = useRouteMatch();
  const update_context = useContext(UpdateContext);

  return (
    <iframe
      style={{ width: "100vw", height: "100vh" }}
      src={
        update_context.settings.url + location.pathname.substr(match.url.length)
      }
      title={match.url}
    ></iframe>
  );
}
